import { useQueryClient } from '@tanstack/react-query';
import { dryRunSyncOrgFromEdlink, getOrg, invalidateOrgQueries, syncOrgFromEdlink } from '@/lib/api-calls.js';
import { SyncEdlinkModal } from '@/components/edlink/sync-edlink-modal.js';

type SyncEdlinkDistrictProps = {
  orgId: string;
  districtName: string;
  districtId: string;
  trigger: React.ReactNode;
};

export const SyncEdlinkDistrict = ({ orgId, districtName, districtId, trigger }: SyncEdlinkDistrictProps) => {
  const queryClient = useQueryClient();

  return (
    <SyncEdlinkModal
      modalTitle="Sync Edlink district"
      entityName={districtName}
      entityId={districtId}
      trigger={trigger}
      syncFn={() => syncOrgFromEdlink(orgId)}
      dryRunFn={() => dryRunSyncOrgFromEdlink(orgId)}
      onSyncSuccess={() => {
        invalidateOrgQueries(queryClient);
        queryClient.invalidateQueries(getOrg(orgId));
      }}
      syncSentryTags={{ feature: 'edlink-sync-district', districtId }}
      dryRunSentryTags={{ feature: 'edlink-sync-district-dry-run', districtId }}
      syncErrorMessage="Edlink District sync failed. Please try again or contact support."
    />
  );
};
